// A viewer's selection never changes what other participants publish.
export function reconcileCallSelection(
  tracks,
  selectedId,
  previousIds,
  unseen
) {
  const ids = tracks.map(item => item.id);
  const selected = ids.includes(selectedId)
    ? selectedId
    : tracks.find(item => item.source === 'screen_share')?.id ||
      tracks[0]?.id ||
      null;
  const fresh = previousIds.length
    ? tracks
        .filter(
          item =>
            item.source === 'screen_share' && !previousIds.includes(item.id)
        )
        .map(item => item.id)
    : [];
  return {
    selectedId: selected,
    unseen: [...new Set([...unseen, ...fresh])].filter(
      id => ids.includes(id) && id !== selected
    ),
  };
}
